function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDacsLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 779 763",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Direct-Air",
    x: 0.072,
    y: 0.196,
    width: 778.303,
    height: 762.189,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M215.562,157.857C211.918,156.537 208.005,155.787 203.931,155.697L203.25,80.137C203.205,75.142 205.331,70.374 209.077,67.069C212.822,63.765 217.819,62.249 222.769,62.917C230.288,63.948 237.804,66.197 244.308,69.746L215.562,157.857Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.308,69.746C268.122,82.679 278.461,112.873 226.214,163.802C223.049,161.266 219.458,159.238 215.562,157.857L244.308,69.746Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M215.562,527.195C211.918,525.875 208.005,525.125 203.931,525.034L203.25,449.475C203.205,444.48 205.331,439.712 209.077,436.407C212.822,433.102 217.819,431.587 222.769,432.254C230.288,433.286 237.804,435.535 244.308,439.083L215.562,527.195Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.308,439.083C268.122,452.017 278.461,482.211 226.214,533.14C223.049,530.603 219.458,528.576 215.562,527.195L244.308,439.083Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M587.815,157.857C584.172,156.537 580.259,155.787 576.184,155.697L575.504,80.137C575.458,75.142 577.584,70.374 581.33,67.069C585.076,63.765 590.072,62.249 595.022,62.917C602.542,63.948 610.058,66.197 616.561,69.746L587.815,157.857Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.561,69.746C640.376,82.679 650.714,112.873 598.468,163.802C595.303,161.266 591.712,159.238 587.815,157.857L616.561,69.746Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M587.815,527.195C584.172,525.875 580.259,525.125 576.184,525.034L575.504,449.475C575.458,444.48 577.584,439.712 581.33,436.407C585.076,433.102 590.072,431.587 595.022,432.254C602.542,433.286 610.058,435.535 616.561,439.083L587.815,527.195Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.561,439.083C640.376,452.017 650.714,482.211 598.468,533.14C595.303,530.603 591.712,528.576 587.815,527.195L616.561,439.083Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M239.504,186.073C238.826,182.258 237.519,178.495 235.56,174.921L300.656,136.552C304.959,134.015 310.152,133.472 314.886,135.063C319.621,136.655 323.432,140.224 325.329,144.845C328.195,151.873 330.005,159.506 330.184,166.913L239.504,186.073Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.184,166.913C330.89,194.004 309.911,218.054 239.682,198.272C240.296,194.262 240.257,190.139 239.504,186.073L330.184,166.913Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M239.504,555.411C238.826,551.596 237.519,547.832 235.56,544.258L300.656,505.889C304.959,503.353 310.152,502.81 314.886,504.401C319.621,505.993 323.432,509.562 325.329,514.183C328.195,521.21 330.005,528.844 330.184,536.25L239.504,555.411Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.184,536.25C330.89,563.341 309.911,587.391 239.682,567.609C240.296,563.6 240.257,559.476 239.504,555.411L330.184,536.25Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M611.758,186.073C611.079,182.258 609.772,178.495 607.813,174.921L672.909,136.552C677.212,134.015 682.405,133.472 687.14,135.063C691.875,136.655 695.685,140.224 697.582,144.845C700.449,151.873 702.259,159.506 702.438,166.913L611.758,186.073Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.438,166.913C703.144,194.004 682.165,218.054 611.936,198.272C612.55,194.262 612.51,190.139 611.758,186.073L702.438,166.913Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M611.758,555.411C611.079,551.596 609.772,547.832 607.813,544.258L672.909,505.889C677.212,503.353 682.405,502.81 687.14,504.401C691.875,505.993 695.685,509.562 697.582,514.183C700.449,521.21 702.259,528.844 702.438,536.25L611.758,555.411Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.438,536.25C703.144,563.341 682.165,587.391 611.936,567.609C612.55,563.6 612.51,559.476 611.758,555.411L702.438,536.25Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M227.04,220.917C230.004,218.422 232.61,215.408 234.726,211.924L300.503,249.114C304.851,251.573 307.917,255.798 308.907,260.694C309.896,265.591 308.71,270.675 305.657,274.629C301.004,280.625 295.298,286.009 288.973,289.867L227.04,220.917Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.973,289.867C265.865,304.024 234.547,297.881 216.564,227.17C220.344,225.697 223.895,223.601 227.04,220.917L288.973,289.867Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M227.04,590.254C230.004,587.759 232.61,584.745 234.726,581.262L300.503,618.452C304.851,620.91 307.917,625.136 308.907,630.032C309.896,634.928 308.71,640.013 305.657,643.966C301.004,649.963 295.298,655.347 288.973,659.205L227.04,590.254Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.973,659.205C265.865,673.362 234.547,667.219 216.564,596.507C220.344,595.034 223.895,592.939 227.04,590.254L288.973,659.205Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M599.293,220.917C602.258,218.422 604.864,215.408 606.979,211.924L672.756,249.114C677.104,251.573 680.171,255.798 681.16,260.694C682.149,265.591 680.963,270.675 677.91,274.629C673.257,280.625 667.551,286.009 661.227,289.867L599.293,220.917Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.227,289.867C638.118,304.024 606.801,297.881 588.818,227.17C592.597,225.697 596.149,223.601 599.293,220.917L661.227,289.867Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M599.293,590.254C602.258,587.759 604.864,584.745 606.979,581.262L672.756,618.452C677.104,620.91 680.171,625.136 681.16,630.032C682.149,634.928 680.963,640.013 677.91,643.966C673.257,649.963 667.551,655.347 661.227,659.205L599.293,590.254Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.227,659.205C638.118,673.362 606.801,667.219 588.818,596.507C592.597,595.034 596.149,592.939 599.293,590.254L661.227,659.205Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.632,227.544C194.275,228.863 198.188,229.613 202.263,229.704L202.943,305.263C202.989,310.258 200.863,315.027 197.117,318.331C193.371,321.636 188.375,323.151 183.425,322.484C175.905,321.453 168.389,319.203 161.886,315.655L190.632,227.544Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.886,315.655C138.071,302.721 127.733,272.528 179.979,221.598C183.144,224.135 186.735,226.162 190.632,227.544L161.886,315.655Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.632,596.881C194.275,598.201 198.188,598.951 202.263,599.041L202.943,674.601C202.989,679.596 200.863,684.364 197.117,687.669C193.371,690.974 188.375,692.489 183.425,691.821C175.905,690.79 168.389,688.541 161.886,684.992L190.632,596.881Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.886,684.992C138.071,672.059 127.733,641.865 179.979,590.936C183.144,593.472 186.735,595.5 190.632,596.881L161.886,684.992Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M562.885,227.544C566.529,228.863 570.442,229.613 574.516,229.704L575.197,305.263C575.242,310.258 573.116,315.027 569.37,318.331C565.625,321.636 560.628,323.151 555.678,322.484C548.159,321.453 540.643,319.203 534.139,315.655L562.885,227.544Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.139,315.655C510.325,302.721 499.986,272.528 552.233,221.598C555.398,224.135 558.989,226.162 562.885,227.544L534.139,315.655Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M562.885,596.881C566.529,598.201 570.442,598.951 574.516,599.041L575.197,674.601C575.242,679.596 573.116,684.364 569.37,687.669C565.625,690.974 560.628,692.489 555.678,691.821C548.159,690.79 540.643,688.541 534.139,684.992L562.885,596.881Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.139,684.992C510.325,672.059 499.986,641.865 552.233,590.936C555.398,593.472 558.989,595.5 562.885,596.881L534.139,684.992Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M166.689,199.327C167.368,203.142 168.675,206.906 170.634,210.48L105.538,248.849C101.235,251.386 96.042,251.929 91.307,250.337C86.572,248.745 82.762,245.176 80.865,240.555C77.998,233.528 76.188,225.894 76.01,218.488L166.689,199.327Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.01,218.488C75.303,191.397 96.282,167.347 166.512,187.129C165.898,191.138 165.937,195.262 166.689,199.327L76.01,218.488Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M166.689,568.665C167.368,572.48 168.675,576.243 170.634,579.817L105.538,618.187C101.235,620.723 96.042,621.266 91.307,619.675C86.572,618.083 82.762,614.514 80.865,609.893C77.998,602.866 76.188,595.232 76.01,587.825L166.689,568.665Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.01,587.825C75.303,560.735 96.282,536.684 166.512,556.466C165.898,560.476 165.937,564.599 166.689,568.665L76.01,587.825Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M538.943,199.327C539.621,203.142 540.928,206.906 542.887,210.48L477.791,248.849C473.488,251.386 468.295,251.929 463.561,250.337C458.826,248.745 455.016,245.176 453.118,240.555C450.252,233.528 448.442,225.894 448.263,218.488L538.943,199.327Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.263,218.488C447.557,191.397 468.536,167.347 538.765,187.129C538.151,191.138 538.19,195.262 538.943,199.327L448.263,218.488Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M538.943,568.665C539.621,572.48 540.928,576.243 542.887,579.817L477.791,618.187C473.488,620.723 468.295,621.266 463.561,619.675C458.826,618.083 455.016,614.514 453.118,609.893C450.252,602.866 448.442,595.232 448.263,587.825L538.943,568.665Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.263,587.825C447.557,560.735 468.536,536.684 538.765,556.466C538.151,560.476 538.19,564.599 538.943,568.665L448.263,587.825Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M179.154,164.484C176.189,166.979 173.583,169.993 171.468,173.476L105.691,136.286C101.343,133.828 98.276,129.602 97.287,124.706C96.298,119.81 97.484,114.725 100.537,110.772C105.19,104.776 110.896,99.391 117.221,95.533L179.154,164.484Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.221,95.533C140.329,81.376 171.646,87.519 189.629,158.231C185.85,159.704 182.299,161.8 179.154,164.484L117.221,95.533Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M179.154,533.821C176.189,536.317 173.583,539.33 171.468,542.814L105.691,505.624C101.343,503.165 98.276,498.94 97.287,494.044C96.298,489.147 97.484,484.063 100.537,480.109C105.19,474.113 110.896,468.729 117.221,464.871L179.154,533.821Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.221,464.871C140.329,450.714 171.646,456.857 189.629,527.568C185.85,529.041 182.299,531.137 179.154,533.821L117.221,464.871Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M551.407,164.484C548.443,166.979 545.837,169.993 543.721,173.476L477.945,136.286C473.596,133.828 470.53,129.602 469.541,124.706C468.551,119.81 469.737,114.725 472.791,110.772C477.443,104.776 483.149,99.391 489.474,95.533L551.407,164.484Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.474,95.533C512.582,81.376 543.9,87.519 561.883,158.231C558.103,159.704 554.552,161.8 551.407,164.484L489.474,95.533Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M551.407,533.821C548.443,536.317 545.837,539.33 543.721,542.814L477.945,505.624C473.596,503.165 470.53,498.94 469.541,494.044C468.551,489.147 469.737,484.063 472.791,480.109C477.443,474.113 483.149,468.729 489.474,464.871L551.407,533.821Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.474,464.871C512.582,450.714 543.9,456.857 561.883,527.568C558.103,529.041 554.552,531.137 551.407,533.821L489.474,464.871Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.097,24.693C110.371,24.693 35.09,99.975 35.09,192.7C35.09,285.426 110.371,360.707 203.097,360.707C295.822,360.707 371.104,285.426 371.104,192.7C371.104,99.975 295.822,24.693 203.097,24.693ZM203.097,44.253C285.027,44.253 351.544,110.77 351.544,192.7C351.544,274.63 285.027,341.147 203.097,341.147C121.167,341.147 54.65,274.63 54.65,192.7C54.65,110.77 121.167,44.253 203.097,44.253Z",
    style: {
      fill: "rgb(204,204,204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.097,394.031C110.371,394.031 35.09,469.312 35.09,562.038C35.09,654.763 110.371,730.045 203.097,730.045C295.822,730.045 371.104,654.763 371.104,562.038C371.104,469.312 295.822,394.031 203.097,394.031ZM203.097,413.591C285.027,413.591 351.544,480.108 351.544,562.038C351.544,643.968 285.027,710.485 203.097,710.485C121.167,710.485 54.65,643.968 54.65,562.038C54.65,480.108 121.167,413.591 203.097,413.591Z",
    style: {
      fill: "rgb(204,204,204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.35,24.693C482.625,24.693 407.343,99.975 407.343,192.7C407.343,285.426 482.625,360.707 575.35,360.707C668.076,360.707 743.357,285.426 743.357,192.7C743.357,99.975 668.076,24.693 575.35,24.693ZM575.35,44.253C657.28,44.253 723.797,110.77 723.797,192.7C723.797,274.63 657.28,341.147 575.35,341.147C493.42,341.147 426.904,274.63 426.904,192.7C426.904,110.77 493.42,44.253 575.35,44.253Z",
    style: {
      fill: "rgb(204,204,204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.35,394.031C482.625,394.031 407.343,469.312 407.343,562.038C407.343,654.763 482.625,730.045 575.35,730.045C668.076,730.045 743.357,654.763 743.357,562.038C743.357,469.312 668.076,394.031 575.35,394.031ZM575.35,413.591C657.28,413.591 723.797,480.108 723.797,562.038C723.797,643.968 657.28,710.485 575.35,710.485C493.42,710.485 426.904,643.968 426.904,562.038C426.904,480.108 493.42,413.591 575.35,413.591Z",
    style: {
      fill: "rgb(204,204,204)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.097,
    cy: 192.7,
    r: 29.302,
    style: {
      fill: "rgb(204,204,204)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.097,
    cy: 562.038,
    r: 29.302,
    style: {
      fill: "rgb(204,204,204)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.35,
    cy: 192.7,
    r: 29.302,
    style: {
      fill: "rgb(204,204,204)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.35,
    cy: 562.038,
    r: 29.302,
    style: {
      fill: "rgb(204,204,204)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDacsLight);
export default __webpack_public_path__ + "static/media/dacs-light.2c1ca07d129f4bed0c5d0de54373b29a.svg";
export { ForwardRef as ReactComponent };